import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { types } from './types';
import { login, logout } from './thunks';

const authStore = (store: RootState) => store?.auth;

const selectIsLoggedIn = createSelector(
  [authStore],
  (store) => store?.isLoggedIn ?? false
);

const selectAuthUser = createSelector([authStore], (store) => store?.user);

const selectIsGuestUser = createSelector(
  [authStore],
  (store) => store?.isGuestUser
);

const selectAuthUserRole = createSelector(
  [authStore],
  (store) => store?.user?.role
);

const selectHasChildrenSetupCompleted = createSelector(
  [selectAuthUser],
  (user) => {
    const { childrenCount, childrenSetupRequiredCount } = user ?? {};
    return (childrenCount ?? 0) > 0 && childrenSetupRequiredCount === 0;
  }
);

export {
  login,
  types,
  logout,
  selectAuthUser,
  selectIsLoggedIn,
  selectIsGuestUser,
  selectAuthUserRole,
  selectHasChildrenSetupCompleted,
};
